import React, { useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";

import slack from "../../../assets/img/settings/connected-app-01.svg";
import calendar from "../../../assets/img/settings/connected-app-02.svg";
import gmail from "../../../assets/img/settings/connected-app-03.svg";
import github from "../../../assets/img/settings/connected-app-04.svg";

export default function ConnectedApps() {
  const [apps, setApps] = useState([
    {
      name: "Slack",
      img: slack,
      desc: "Team communication platform with channels for group discussions and direct messaging.",
      active: false,
    },
    {
      name: "Google Calendar",
      img: calendar,
      desc: "Google Calendar is a web-based scheduling tool that allows users to create, manage, and share events.",
      active: false,
    },
    {
      name: "Gmail",
      img: gmail,
      desc: "Gmail is a free email service by Google that offers robust spam protection & 15GB of storage.",
      active: false,
    },
    {
      name: "Github",
      img: github,
      desc: "Github is a web-based platform for version control and collaboration, allowing developers to host & review code.",
      active: false,
    },
  ]);

  const toggleApp = (index) => {
    const updated = [...apps];
    updated[index].active = !updated[index].active;
    setApps(updated);
  };

  return (
    <div className="connected-container">
      <h5 className="fw-bold mb-3">Connected Apps</h5>

      <Row>
        {apps.map((app, index) => (
          <Col md={6} key={index} className="mb-3">
            <Card className="connected-card">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  
                  {/* LEFT */}
                  <div className="d-flex align-items-center">
                    <div className="app-icon">
                      <img src={app.img} alt={app.name} />
                    </div>
                    <h6 className="mb-0 ms-2 fw-semibold">
                      {app.name}
                    </h6>
                  </div>

                  {/* TOGGLE */}
                  <Form.Check
                    type="switch"
                    checked={app.active}
                    onChange={() => toggleApp(index)}
                  />
                </div>

                {/* DESCRIPTION */}
                <p className="app-desc">{app.desc}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <style>
          {

               `
               .connected-container {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}

/* CARD */
.connected-card {
  border: 1px solid #eee;
  border-radius: 10px;
  transition: 0.2s;
}

.connected-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* ICON BOX */
.app-icon {
  width: 45px;
  height: 45px;
  background: #f5f6f8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-icon img {
  width: 24px;
  height: 24px;
}

/* DESCRIPTION */
.app-desc {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
  margin-top: 6px;
  line-height: 1.5;
}

/* SWITCH STYLE */
.form-check-input {
  width: 40px;
  height: 20px;
}

.form-check-input:checked {
  background-color: #f97316;
  border-color: #f97316;
}

/* MOBILE */
@media (max-width: 768px) {
  .connected-card {
    padding: 10px;
  }

  .app-icon {
    width: 40px;
    height: 40px;
  }

  .app-desc {
    font-size: 13px;
  }
}`
          }
      </style>
    </div>
  );
}